module.exports = __webpack_public_path__ + "assets/img/cms-computer-1.aa20958c.png";